import React, {useState} from "react"

import './TableToolbarFilters.scss'
import {Button, ButtonSet, Checkbox, CheckboxGroup, Column, Grid, Popover, PopoverContent} from "@carbon/react";
import {Filter} from '@carbon/react/icons';
import PropTypes from "prop-types";

const TableToolbarFilters = (props) => {
  const filtersState = props.filtersState
  const [filterPopoverOpened, setFilterPopoverOpened] = useState(false)
  const [filterSeverityGrave, setFilterSeverityGrave] = useState(filtersState["filter_severity_grave"].enabled)
  const [filterSeverityLieve, setFilterSeverityLieve] = useState(filtersState["filter_severity_lieve"].enabled)
  const [filterSeverityInformativo, setFilterSeverityInformativo] = useState(filtersState["filter_severity_informativo"].enabled)
  const [filterH24Only, setFilterH24Only] = useState(filtersState["filter_h24_only"].enabled)

  const handleFiltersApply = () => {
    props.onFiltersChange(buildFiltersObject(filterSeverityGrave, filterSeverityLieve, filterSeverityInformativo, filterH24Only))
    setFilterPopoverOpened(false)
  }

  const handleFiltersReset = () => {
    props.onFiltersChange(buildFiltersObject(true, true, true, false))
    setFilterPopoverOpened(false)
  }

  const buildFiltersObject = (grave, lieve, info, onlyH24) => {
    return {
      "filter_severity_grave": {
        value: "Grave", enabled: grave
      }, "filter_severity_lieve": {
        value: "Lieve", enabled: lieve
      }, "filter_severity_informativo": {
        value: "Informativo", enabled: info
      }, "filter_h24_only": {
        enabled: onlyH24
      }
    }
  }

  return (
    <Popover
      open={filterPopoverOpened}
      isTabTip
      autoAlign
      align="bottom-right"
      caret={false}>
      <Button
        kind="ghost"
        size="lg"
        onClick={() => {
          setFilterPopoverOpened(!filterPopoverOpened)
        }}>
        <Filter/>
      </Button>
      <PopoverContent className="p-3">
        <Grid style={{padding: "20px"}}>
          <Column lg={16} md={4} sm={4} style={{marginBottom: "1rem"}}>
            <CheckboxGroup legendText="Priorità">
              <Checkbox id="severity-grave" labelText="Grave" invalidText="" warnText="" checked={filterSeverityGrave}
                        onChange={(ev, {checked, id}) => {
                          setFilterSeverityGrave(checked)
                        }}/>
              <Checkbox id="severity-lieve" labelText="Lieve" invalidText="" warnText="" checked={filterSeverityLieve}
                        onChange={(ev, {checked, id}) => {
                          setFilterSeverityLieve(checked)
                        }}/>
              <Checkbox id="severity-info" labelText="Informativo" invalidText="" warnText=""
                        checked={filterSeverityInformativo}
                        onChange={(ev, {checked, id}) => {
                          setFilterSeverityInformativo(checked)
                        }}/>
            </CheckboxGroup>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <CheckboxGroup legendText="H24">
              <Checkbox id="only-h24" labelText="Solo H24" invalidText="" warnText="" checked={filterH24Only}
                        onChange={(ev, {checked, id}) => {
                          setFilterH24Only(checked)
                        }}/>
            </CheckboxGroup>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4}>
            <ButtonSet className="alarms-page-alarms-filters-form-btn">
              <Button style={{maxWidth: "50%"}} size="lg" kind="secondary" onClick={handleFiltersReset}>Resetta</Button>
              <Button style={{maxWidth: "50%"}} size="lg" type="button" kind="primary"
                      onClick={handleFiltersApply}>Applica</Button>
            </ButtonSet>
          </Column>
        </Grid>
      </PopoverContent>
    </Popover>
  )
}

TableToolbarFilters.propTypes = {
  filtersState: PropTypes.object.isRequired, onFiltersChange: PropTypes.func.isRequired,
}

export default TableToolbarFilters